module.exports = __webpack_public_path__ + "images/sym_smallaa4f2a5a039c375fd53a99193bd567b6.png";